interface FairHeadLike {
  push: (input: Record<string, unknown>) => { patch: (input: Record<string, unknown>) => void }
}

/** Bound to ViteSSG `head` in main.ts — do not create a second head instance. */
let fairHead: FairHeadLike | null = null

export function bindFairHead(head: FairHeadLike): void {
  fairHead = head
}

export function getFairHead(): FairHeadLike {
  if (!fairHead) {
    throw new Error('Fair head is not bound. Call bindFairHead() from ViteSSG setup.')
  }
  return fairHead
}
